export default "__VITE_ASSET__9ECF19Sn__$_?nuxt_component=async&nuxt_component_name=Svgo铂金舱&nuxt_component_export=default__"